import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7b96ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-contents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lead-message" }, [
  /*#__PURE__*/_createElementVNode("p", null, "ログインできました"),
  /*#__PURE__*/_createElementVNode("p", null, "資料（ファイル等）を送信してください")
], -1))
const _hoisted_3 = { class: "action" }
const _hoisted_4 = { class: "send-item" }
const _hoisted_5 = { class: "button-content" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, " 資料を送信 ", -1))
const _hoisted_8 = { class: "check-item" }
const _hoisted_9 = { class: "button-content" }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "message" }, [
  /*#__PURE__*/_createTextVNode(" 送信した資料を"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 確認 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, [
        _createVNode(_component_AppButton, {
          styled: 'is-accent',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('outer/outputSelect'))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('outer/outputSelect')), ["prevent"]), ["space","enter"])),
          buttonId: 'button-sendItem'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_DssIcon, { icon: 'envelope-fill' })
              ]),
              _hoisted_7
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createVNode(_component_AppButton, {
          styled: 'is-accent',
          disabled: _ctx.disabledFlag,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('outer/list'))),
          onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('outer/list')), ["prevent"]), ["space","enter"])),
          buttonId: 'button-checkItem'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_DssIcon, { icon: 'document-book' })
              ]),
              _hoisted_11
            ])
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}